document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.review_container_hoox', {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '.hoox-swiper-arrow-next-customreviewsec',
        prevEl: '.hoox-swiper-arrow-prev-customreviewsec',
      },
      pagination: {
        el: '.swiper-pagination-customreviewsec',
        clickable: true,
      },
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        0: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    });
  
  });